import {
  Paper,
  Grid,
  Typography,
  Button,
  CircularProgress
} from '@material-ui/core'
import React, { useState } from 'react'
import classes from './index.module.css'

function Rejection ({
  confirmLabel,
  confirmAction,
  headerLabel,
  cancelAction
}) {
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  return (
    <div className={classes.container}>
      <Grid container>
        <Grid xs={12}>
          <Typography variant='h5'>{headerLabel}</Typography>
        </Grid>
        <Grid xs={12}>
          <div className={classes.textarea}>
            <label>Reasons:</label>
            <textarea
              rows={10}
              value={message}
              onChange={e => setMessage(e.target.value)}
            />
          </div>
        </Grid>
        <Grid xs={12}>
          <div className={classes.errorMessage}>{error}</div>
        </Grid>
        <Grid xs={12}>
          <div className={classes.actionButtons}>
            <Button
              disabled={loading}
              variant='contained'
              onClick={cancelAction}
            >
              Cancel
            </Button>
            <Button
              disabled={loading}
              variant='contained'
              onClick={async () => {
                setLoading(true)
                const result = await confirmAction(message)
                if (result.status === 'error') {
                  setError(result.message)
                  setLoading(false)
                }
                if (result.status === 'success') {
                  window.location.reload()
                }
              }}
            >
              {!loading && confirmLabel}
              {loading && <CircularProgress size={20} />}
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default Rejection
